export const VEHICLETYPE_PASSENGER_CAR = 'VEHICLETYPE_PASSENGER_CAR';
